import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Pagination from "./Pagination";

const { REACT_APP_API } = process.env;

const NotificationEmail = () => {
    const [pagedEmails, setPagedEmails] = useState({
        docs: [],
        totalDocs: 0,
        limit: 10,
        page: 1,
        totalPages: 1,
        hasNextPage: false,
        nextPage: null,
        hasPrevPage: false,
        prevPage: null,
        pagingCounter: 1,
    });

    const [expandedRows, setExpandedRows] = useState({});
    const [searchOrder, setSearchOrder] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const fetchEmails = useCallback(async () => {
        try {
            const response = await axios.get(
                `${REACT_APP_API}/notificationemail/findNotificationEmail?page=${currentPage}&limit=${pageSize}&search=${searchOrder}`
            );

            setPagedEmails(response.data);

            setExpandedRows({});
        } catch (error) {
            console.error("Error al obtener los correos:", error);
        }
    }, [currentPage, pageSize, searchOrder]);

    function getOrderNumber(email) {
        const params = email?.response?.parameters;
        const numOrder = params?.NUM_ORDER?.toString().trim();
        const nroPedido = params?.NRO_PEDIDO?.toString().trim();


        return numOrder || nroPedido || "order Porta";
    }

    useEffect(() => {
        fetchEmails();
    }, [fetchEmails]);

    const toggleRow = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };


    const handlePageChange = (selectedItem) => {
        setCurrentPage(selectedItem.selected + 1);
    };

    const forcePage = pagedEmails.page - 1;

    const handleOnChangeLimit = (e) => {
        const newPageSize = parseInt(e.target.value, 10);
        setPageSize(newPageSize);
        setCurrentPage(1);
    };

    const handleOnKeyUpSearch = (e) => {
        if (e.keyCode === 13) {
            setSearchOrder(e.target.value);
            setCurrentPage(1);
        }
    };

    return (
        <>
            <div className="container">
                <div className="row my-md-4 my-sm-3 my-3">
                    <div className="col-6">
                        <h3>Bandeja de Entrada</h3>
                    </div>

                    <div className="col-6 text-end"></div>

                    <div className="col-6 col-md-5 mt-2 mb-2">
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <label>Mostrar</label>
                            </div>
                            <div className="col-auto">
                                <select onChange={handleOnChangeLimit} value={pageSize} className="form-select form-select-sm">
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="col-auto">
                                <label> entradas</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-6 col-md-7">
                        <div className="row align-items-center justify-content-end">
                            <div className="col-auto">
                                <label htmlFor="orderInput" className="col-form-label">Buscar por OrdenId</label>
                            </div>
                            <div className="col-auto">
                                <input
                                    id="orderInput"
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Presione Enter"
                                    autoComplete="off"
                                    onKeyUp={handleOnKeyUpSearch}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive col-12 mb-2">
                        <table className="table table-bordered table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th style={{ width: "20%" }}>N° Orden</th>
                                    <th style={{ width: "10%" }}>Code</th>
                                    <th style={{ width: "20%" }}>Service</th>
                                    <th style={{ width: "10%" }}>#Product</th>
                                    <th style={{ width: "40%" }}>Content</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pagedEmails.docs.length > 0 ? (
                                    pagedEmails.docs.map((email, index) => (
                                        <tr key={email._id}>
                                            <td className="text-wrap">{getOrderNumber(email)}</td>
                                            <td className="text-wrap">{email?.code}</td>
                                            <td className="text-wrap">{email?.service}</td>
                                            <td className="text-wrap">{email?.amount}</td>
                                            <td className="text-break" style={{ maxWidth: "450px" }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "flex-start",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            height: expandedRows[index] ? "auto" : "100px",
                                                            overflow: "hidden",
                                                            transition: "height 0.3s ease",
                                                            flex: 1,
                                                        }}
                                                    >
                                                        <pre className="m-0 p-0">{JSON.stringify(email.response, null, 2)}</pre>
                                                    </div>
                                                    <button
                                                        className="btn btn-outline-secondary btn-sm ms-2"
                                                        onClick={() => toggleRow(index)}
                                                    >
                                                        {expandedRows[index] ? "Ver menos" : "Ver más"}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center">No hay registros disponibles</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {pagedEmails.totalDocs > 0 && (
                        <Pagination
                            pagedData={pagedEmails}
                            onPageChange={handlePageChange}
                            forcePage={forcePage}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default NotificationEmail;
